var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.872 20.616C23.495 21.239 23.495 22.249 22.872 22.872C22.249 23.495 21.239 23.495 20.616 22.872L16 18.256L11.384 22.872C10.761 23.495 9.75098 23.495 9.128 22.872C8.50502 22.249 8.50502 21.239 9.128 20.616L13.744 16L9.128 11.384C8.50502 10.761 8.50502 9.75098 9.128 9.128C9.75098 8.50502 10.761 8.50502 11.384 9.128L16 13.744L20.616 9.128C21.239 8.50502 22.249 8.50502 22.872 9.128C23.495 9.75098 23.495 10.761 22.872 11.384L18.256 16L22.872 20.616Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.26a09486d9e2e4b2003ba0097aa1aa14.svg";
export { ForwardRef as ReactComponent };